<template>
  <div>
    <div class="list" v-if="list.length > 0">
      <div v-for="(item, index) in list" :key="index" class="item-list" @click="goToTask(item)">
        <template v-if="item.course_type != 0">
          <div class="item-card">
            <div class="left">
              <div class="time">
                {{ new Date(item.start_play * 1000).format('hh:mm') }}-{{
                  new Date(item.end_play * 1000).format('hh:mm')
                }}
              </div>
              <div class="state-wrap">
                <span class="state state-none" v-if="item.periods_type == 23">
                  <span v-if="item.live_status == 0">未开课</span>
                  <span v-else-if="item.live_status == 1" class="living">
                    <span class="primary-color">已开课</span>
                  </span>
                  <span
                    v-else-if="
                      item.live_status == 2 || item.live_status == 3 || item.live_status == 4
                    "
                  >
                    <span>已结束</span>
                  </span>
                </span>
                <span
                  class="state"
                  :class="'state-' + item.live_status"
                  v-else-if="item.periods_type == 2 || item.periods_type == 3"
                >
                  <span v-if="item.live_status == 0">未开始</span>
                  <span v-else-if="item.live_status == 1" class="living">
                    <span class="primary-color">直播中</span>
                  </span>
                  <span
                    v-else-if="
                      item.live_status == 2 || item.live_status == 3 || item.live_status == 4
                    "
                  >
                    <span>已结束</span>
                  </span>
                </span>
                <span
                  v-if="item.course_type == 7"
                  class="state"
                  :class="'state-' + item.live_status"
                >
                  <span v-if="item.live_status == 0">未开始</span>
                  <span v-else-if="item.live_status == 1">
                    <span class="primary-color">上课中</span>
                  </span>
                  <span
                    v-else-if="
                      item.live_status == 2 || item.live_status == 3 || item.live_status == 4
                    "
                  >
                    <span>已结束</span>
                  </span>
                </span>
              </div>
            </div>
            <div class="line"></div>
            <div class="main">
              <div class="main-line"></div>
              <div class="main-content">
                <div @click="showDialog(item)" style="cursor: default">
                  <span class="type">{{ item.course_type_name }}</span>
                  <span class="title">
                    <template v-if="item.type == 1">
                      <span v-if="item.chapter_title" style="margin-right: 12px">
                        {{ item.chapter_title }}
                      </span>
                    </template>
                    <span v-if="item.course_type != 1">
                      {{ item.title }}
                    </span>
                    <span v-else>{{ item.teacher_name }}</span>
                  </span>
                </div>
                <div class="subtitle" v-if="item.course_title">
                  {{ item.course_title }}
                </div>
                <div class="subtitle" v-else-if="item.oto_desc">
                  {{ item.oto_desc }}
                </div>
                <template v-if="item.type == 1 || item.type == 2">
                  <FileList :fileList="item.notes || []" />
                </template>
                <template v-if="item.type != 1 && item.type != 2 && item.notes_status == 1">
                  <FileList :fileList="[{ ...item, ware_filename: item.notes_name }]" />
                </template>
              </div>
              <div class="live-state" v-if="!isInterActive">
                <template
                  v-if="
                    item.course_type == 1 ||
                    item.course_type == 2 ||
                    item.course_type == 3 ||
                    item.course_type == 15 ||
                    item.course_type == 16 ||
                    item.course_type == 23
                  "
                >
                  <span
                    v-if="item.live_status == 0"
                    class="period-living"
                    @click.stop="goToPlay(item)"
                  >
                    立即进入
                  </span>
                  <span
                    v-else-if="item.live_status == 1"
                    class="period-living"
                    @click.stop="goToPlay(item)"
                  >
                    立即进入
                  </span>
                  <template v-else>
                    <template v-if="item.course_type == 16">
                      <span v-if="item.live_status == 3" @click.stop="goToPlay(item, 1)">
                        大班回放
                      </span>
                      <span v-if="item.live_status == 3" @click.stop="goToPlay(item)">
                        小班回放
                      </span>
                    </template>
                    <span v-else-if="item.course_type == 23" @click.stop="goToPlay(item, 1)">
                      课程回放
                    </span>
                    <span v-else-if="item.live_status == 3" @click.stop="goToPlay(item)">
                      查看回放
                    </span>
                    <span class="disabled" v-else :style="{ cursor: 'not-allowed' }">
                      查看回放
                    </span>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-if="item.course_type == 0">
          <MeetingCard :item="getMeetingInfo(item)" @goToPlay="goToMeeting" />
        </template>
      </div>
    </div>
    <EmptyNew class="empty" title="暂无内容" v-else />
    <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip v-if="showSoldOut" :show.sync="showSoldOut"></CourseSoldOutTip>

    <ContactTeacherDialog
      :visible="showContactTeacherDialog"
      :interceptText="currentItem.interception_info?.interceptText.split('_')[0]"
      :wechatWorkQrCode="currentItem.interception_info?.wechat_work_qr_code"
      @close="showContactTeacherDialog = false"
    />
  </div>
</template>
<script>
import CourseSoldOutTip from '@/modules/stu/components/CourseSoldOutTip.vue';
import MeetingCard from './classes/MeetingCard';
import EmptyNew from '@/components/EmptyNew.vue';
import FileList from '@/modules/stu/components/FileList';
import CourseContentTip from '@/modules/stu/components/CourseContentTip';
import ContactTeacherDialog from './ContactTeacherDialog';

export default {
  name: 'StudyCalendarItem',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    isInterActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentItem: {},
      showContactTeacherDialog: false,
      PeriodTypeEnum: {
        ALL: 0,
        OTO_CLASS: 1, //一对一 约课
        BIG_CLASS: 2, //大班课
        SMALL_CLASS: 3, //小班课
        PUBLIC_CLASS: 4, //公开课
        VIDEO_CLASS: 5, //点播课
        FACE_CLASS: 7, //面授课
        AUDIO_CLASS: 8, //音频课
        SYSTEM_CLASS: 9, //系统课
        PICTURE_CLASS: 10, // 图文课
        VIP_CLASS: 11, //vip课
        GROUP_CLASS: 15, //分组课课节
        DOUBLE_TEACHER_CLASS: 16, //双师课
        MULTIPLE_CLASS: 22, //混合课
      },
      showContentDialog: false,
      chapter_content: '',
      // list: [],
      id: this.$route.params.id,
      showSoldOut: false,
      // hideMore: null,
      fileList: [],
    };
  },
  components: {
    CourseSoldOutTip,
    MeetingCard,
    EmptyNew,
    FileList,
    CourseContentTip,
    ContactTeacherDialog,
  },
  methods: {
    goToTask(item) {
      if (!this.isInterActive) {
        return;
      }
      this.$router.push({
        name: 'MemberStudyTask',
        query: { d: item.start_play },
      });
    },
    showDialog(row) {
      if (row.periods_type == 7) {
        this.showContentDialog = true;
        this.chapter_content = row.content;
      }
    },
    getMeetingInfo(item) {
      let live_status;
      if (item.live_status == 0) {
        live_status = 1;
      } else if (item.live_status == 1) {
        live_status = 2;
      } else {
        live_status = 3;
      }
      return {
        ...item,
        start_time: item.start_play,
        end_time: item.end_play,
        live_status: live_status,
      };
    },
    //进入班会  id,type
    goToMeeting(data, type) {
      this.$livePlay(0, 'meeting', {
        id: 0,
        title: data.meeting_name,
        meeting_id: data.id,
        type: type,
      });
    },

    isLive(courseType) {
      return (
        courseType === this.PeriodTypeEnum.BIG_CLASS ||
        courseType === this.PeriodTypeEnum.SMALL_CLASS ||
        courseType === this.PeriodTypeEnum.PUBLIC_CLASS ||
        courseType === this.PeriodTypeEnum.OTO_CLASS ||
        courseType === this.PeriodTypeEnum.GROUP_CLASS ||
        courseType === this.PeriodTypeEnum.MULTIPLE_CLASS
      );
    },
    isFace(courseType) {
      return this.PeriodTypeEnum.FACE_CLASS === courseType;
    },
    getPlayTypeTitle(courseType, playType) {
      if (this.isLive(courseType)) {
        if (playType === 1) {
          return '未开始';
        } else if (playType === 2) {
          return '直播中';
        } else if (playType === 3 || playType === 5) {
          return '已结束';
        } else if (playType === 4) {
          return '回放';
        } else if (this.isFace(courseType)) {
          if (playType === 1) {
            return '未开始';
          } else if (playType === 2) {
            return '开课中';
          } else if (playType === 3 || playType === 5) {
            return '已结束';
          } else if (playType === 4) {
            return '已结束';
          }
        } else {
          return '';
        }
      }
    },
    handleSendViewTrack(item) {
      this.$webSeeSendTrack({
        event_id: 'my_study_calendar_course_item_show',
        data: {
          cousrse_info: {
            course_id: item.course_basis_id,
            title: item.course_title,
            course_type: item.course_type,
          },
          section_info: {
            section_id: item.course_chapter_id,
            section_status: this.getPlayTypeTitle(item.course_type, item.live_status),
          },
          live_info: {
            platform: 'pc',
            roomId: item.room_video_id,
          },
          others: {
            from: 'study_calendar',
          },
        },
      });
    },

    async goToPlay(item, type) {
      if (item.interception_info) {
        this.currentItem = item;
        this.showContactTeacherDialog = true;
        return;
      }
      if (item.status == 2 && item.is_go_to_study == 0) {
        this.showSoldOut = true;
        return;
      }
      if (item.course_type == 16) {
        if (!type) {
          type = 2;
        }
      } else if (!type) {
        type = 1;
      }
      if (type == 1 && (item.live_status == 2 || item.live_status == 4)) {
        return;
      }
      if (type == 2 && (item.min_live_status == 2 || item.min_live_status == 4)) {
        return;
      }
      if (item.valid_status != 1) {
        return this.$info('该课程已过期，无法继续学习');
      }
      if (item.course_type != 1) {
        await this.$services.CourseService.checkLimit(item.course_basis_id, item.course_chapter_id);
      }
      this.$livePlay(item.course_basis_id, item.course_type, {
        id: item.course_chapter_id,
        title: item.title,
        type: type,
        period_id: item.periods_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  padding: 0 24px 30px 0;
}
.item-list {
  &:last-child {
    ::v-deep .line::after {
      display: none !important;
    }
    ::v-deep .main {
      margin-bottom: 0 !important;
    }
  }
}
.item-card {
  display: flex;
  //&:last-child {
  //  .line::after {
  //    display: none;
  //  }
  //  .main {
  //    margin-bottom: 0;
  //  }
  //}
  .left {
    margin-right: 16px;
    margin-top: 18px;
    width: 115px;
  }
  .main {
    flex: 1;
    display: flex;
    align-items: center;
    margin-bottom: 35px;
    border: 1px solid #e6e6e6;
    border-left: none;
    padding: 18px 16px 18px 18px;
    position: relative;
  }
  .main-line {
    position: absolute;
    height: 100%;
    width: 4px;
    left: 0;
    top: 0;
    background: #f39b10;
  }
  .main-content {
    flex: 1;
  }
  .time {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    height: 22px;
    line-height: 22px;
    display: flex;
    justify-content: flex-end;
  }
  .line {
    position: relative;
    width: 10px;
    margin: 0 24px 0 0;

    &::before {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      box-sizing: border-box;
      border: 2px solid #f39b10;
      border-radius: 50%;
      background: #fce6c3;
      z-index: 1;
      top: 24px;
    }
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 100%;
      box-sizing: border-box;
      border-left: 2px dashed #dadada;
      left: 4px;
      top: 30px;
    }
  }
  .type {
    font-size: 12px;
    color: $primary-color;
    background: $primary-color-light;
    padding: 3px 6px;
    border-radius: 4px;
    margin-right: 8px;
  }
  .type-arrange {
    font-size: 12px;
    color: #ec8e0f;
    background: #fff5dc;
    padding: 3px 6px;
    border-radius: 4px;
    margin-right: 10px;
  }
  .state-wrap {
    display: flex;
    justify-content: flex-end;
    padding-top: 2px;
  }
  .state {
    font-size: 14px;
    color: #999999;
    padding-left: 20px;
    background-image: url('~@/assets/images/calendar/end@2x.png');
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: left center;
  }
  .state-0 {
    background-image: url('~@/assets/images/calendar/wait@2x.png');
  }
  .state-1 {
    background-image: url('~@/assets/images/calendar/living@2x.png');
  }
  .state-none {
    background-image: none;
  }
  .living {
    color: $primary-color;
  }
  .title {
    font-size: 14px;
  }
  .subtitle {
    color: #999999;
    margin-top: 8px;
  }
  .subtitle-line {
    margin: 0 8px;
    color: #d8d8d8;
  }
  .live-state {
    display: flex;
    position: relative;
    span {
      font-size: 14px;
      border: 1px solid #bfbfbf;
      cursor: pointer;
      border-radius: 19px;
      margin-left: 10px;
      padding: 7px 20px;
      &:first-child {
        margin-left: 0;
      }
      &:hover {
        border-color: $primary-color;
        color: $primary-color;
      }
      &.disabled {
        color: #333333;
        background: #f5f5f5;
        opacity: 0.5;
        cursor: not-allowed !important;

        &:hover {
          background: #f5f5f5;
          color: #333333;
          cursor: default;
          border-color: #bfbfbf;
        }
      }
    }
    .text-disabled {
      position: relative;
      top: 2px;
      border: none;
      cursor: default;
      vertical-align: middle;
      &.disabled {
        color: #999;
        background: #fff;
        &:hover {
          background: #fff;
          color: #999;
          cursor: default;
        }
      }
    }
    .more {
      width: 36px;
      padding: 0;
      text-align: center;
      line-height: 34px;
      background: url('~@/assets/images/calendar/more@2x.png') no-repeat center center/16px 4px;
    }
    .more-panel {
      position: absolute;
      right: 0;
      top: 40px;
      width: 128px;
      padding: 4px 0;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .more-item {
      height: 36px;
      padding-left: 12px;
      line-height: 36px;
      cursor: pointer;
      &:hover {
        background: $primary-color-light;
        color: $primary-color;
      }
    }
  }
}
</style>
